import { IClasseRepository } from "@app/features/Classe/data/classeRespository";

const removeStudentsFromClasseUseCase = async (
  repository: Pick<IClasseRepository, "removeUsersFromClasse">,
  classeId: number,
  userId: number
): Promise<void> => {
  await repository.removeUsersFromClasse(classeId, userId);
};

export default removeStudentsFromClasseUseCase;
